import type { ControlSettings } from './ControlSettings';

export function readGamepads(): (Gamepad | null)[] {
  try { return Array.from(navigator.getGamepads?.() ?? []); }
  catch { return []; }
}

export function assignGamepads(settings: ControlSettings, pads: readonly (Gamepad | null)[], previous: readonly number[] = [-1, -1]): number[] {
  const assigned = settings.map(control => control.mode === 'gamepad' ? control.padIndex : -1);
  for (let player = 0; player < 2; player += 1) {
    if (settings[player].mode === 'gamepad' && settings[player].padIndex < 0 && pads[previous[player]]?.connected && !assigned.includes(previous[player])) assigned[player] = previous[player];
  }
  for (let player = 0; player < 2; player += 1) {
    if (settings[player].mode !== 'gamepad' || settings[player].padIndex >= 0 || assigned[player] >= 0) continue;
    assigned[player] = pads[player]?.connected && !assigned.includes(player) ? player
      : pads.findIndex((pad, index) => pad?.connected && !assigned.includes(index));
  }
  return assigned;
}

export function padButton(pad: Gamepad, index: number): boolean {
  const button = pad.buttons[index];
  return button?.pressed === true || (button?.value ?? 0) > 0.5;
}
